import cookiesPolicy from "fg-frontend/components/CookiesPolicy4/index";

cookiesPolicy({
	disableRwdImg: true,
	enableModal: true,
	enableRenderModalFooterTechnicalButton: true,
});


// WEBPACK FOOTER //
// ./config/module-publish/resources-skoda/js/configureWeb.js